/*
 * @Descripttion: 升序or降序排列
 * @Author: chenjinsheng
 * @Date: 2021-09-27 10:46:47
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-13 18:12:54
 */
export default {
    methods: {
        /**
         * 升序or降序排列(自定义)
         * 1.点击文字(点击非当前文字、点击当前文字)
         * 2.点击图标
         */
        sortChange(fieldVale, status) {
            if (!status) {
                this.searchOpt.orderByType = fieldVale;
                if (this.searchOpt.orderByType !== fieldVale) {
                    this.searchOpt.orderBy = "down";
                } else {
                    if (this.searchOpt.orderBy === "down") {
                        this.searchOpt.orderBy = "up";
                    } else if (this.searchOpt.orderBy === "up") {
                        this.searchOpt.orderBy = "";
                        this.searchOpt.orderByType = "";
                    } else if (this.searchOpt.orderBy === "") {
                        this.searchOpt.orderBy = "down";
                    }
                }
            } else {
                this.searchOpt.orderByType = fieldVale;
                this.searchOpt.orderBy = status;
            }
            this.getList();
        },
    },
};
